import { render } from "./obligations_register.html?vue&type=template&id=3bc55e0f&external"
import script from "./obligations_register.js?vue&type=script&lang=js&external"
export * from "./obligations_register.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__